import * as actionTypes from '@/store/actions.type';
import * as mutationTypes from '@/store/mutations.type';
import api from '@/api';
import _ from 'lodash';

const getDefaultNotificationParams = () => {
  return {
    take: null,
    skip: null,
  }
};

const state = {
  notifications: [],
  params: getDefaultNotificationParams(),
  totalNotificationsCount: 0,
  notReadNotificationsCount: 0,
  checkNotReadNotificationsCount: 0,
  hasMoreToLoad: false
};

const getters = {
  notifications: state => state.notifications,
  totalNotificationsCount: state => state.totalNotificationsCount,
  notReadNotificationsCount: state => state.notReadNotificationsCount,
  checkNotReadNotificationsCount: state => state.checkNotReadNotificationsCount,
  hasMoreToLoad: state => state.hasMoreToLoad,
};

const actions = {
  async [actionTypes.FETCH_NOTIFICATIONS] ({ commit }, payload) {
    commit(mutationTypes.UPDATE_NOTIFICATION_PARAMS, payload);

    const { data } = await api.notifications.get(state.params);

    commit(mutationTypes.UPDATE_TOTAL_NOTIFICATIONS_COUNT, data.totalNotificationsCount);
    commit(mutationTypes.UPDATE_TOTAL_NOT_READ_NOTIFICATIONS_COUNT, data.notReadNotificationsCount);
    commit(mutationTypes.UPDATE_HAS_MORE_TO_LOAD, data.hasMoreToLoad);
    commit(mutationTypes.UPDATE_LIST_OF_NOTIFICATIONS, data.notifications);
  },
  async [actionTypes.LOAD_MORE_NOTIFICATIONS] ({ commit }, payload) {
    commit(mutationTypes.UPDATE_NOTIFICATION_PARAMS, payload);

    const { data } = await api.notifications.get(state.params);

    commit(mutationTypes.UPDATE_TOTAL_NOTIFICATIONS_COUNT, data.totalNotificationsCount);
    commit(mutationTypes.UPDATE_TOTAL_NOT_READ_NOTIFICATIONS_COUNT, data.notReadNotificationsCount);
    commit(mutationTypes.UPDATE_HAS_MORE_TO_LOAD, data.hasMoreToLoad);
    commit(mutationTypes.EXTEND_LIST_OF_NOTIFICATIONS, data.notifications);
  },
  async [actionTypes.UPDATE_READ_STATUS] ({ commit }, payload) {
    const { data } = await api.notifications.update(payload);

    commit(mutationTypes.UPDATE_TOTAL_NOT_READ_NOTIFICATIONS_COUNT, data);
  },
  async [actionTypes.GET_NOT_READ_NOTIFICATIONS_COUNT] ({ commit }, payload) {
    const { data } = await api.notifications.getNotReadCount();

    commit(mutationTypes.UPDATE_CHECK_NOT_READ_NOTIFICATIONS_COUNT, data);
  },
  [actionTypes.RESET_NOTIFICATION_PARAMS] ({ commit }) {
    commit(mutationTypes.RESET_NOTIFICATION_PARAMS)
  }
};

const mutations = {
  [mutationTypes.UPDATE_LIST_OF_NOTIFICATIONS] (state, payload) {
    state.notifications = payload;
  },
  [mutationTypes.EXTEND_LIST_OF_NOTIFICATIONS] (state, payload) {
    state.notifications = [...state.notifications, ...payload];
  },
  [mutationTypes.UPDATE_TOTAL_NOTIFICATIONS_COUNT] (state, payload) {
    state.totalNotificationsCount = payload;
  },
  [mutationTypes.UPDATE_TOTAL_NOT_READ_NOTIFICATIONS_COUNT] (state, payload) {
    state.notReadNotificationsCount = payload;
  },
  [mutationTypes.UPDATE_CHECK_NOT_READ_NOTIFICATIONS_COUNT] (state, payload) {
    state.checkNotReadNotificationsCount = payload;
  },
  [mutationTypes.UPDATE_HAS_MORE_TO_LOAD] (state, payload) {
    state.hasMoreToLoad = payload;
  },
  [mutationTypes.UPDATE_NOTIFICATION_PARAMS] (state, payload) {
    state.params = _.extend(state.params, payload);
  },
  [mutationTypes.RESET_NOTIFICATION_PARAMS] (state) {
    state.params = JSON.parse(JSON.stringify(getDefaultNotificationParams()));
  },
};

export default {
  state,
  actions,
  mutations,
  getters
}